<template>
  <div v-loading="loading" class="page-form">
    <h3 class="title">发货计划编制</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <btky-header
          :form-data="conditions"
          :process-key="processKey"
          @validate="validate"
          @formDataSave="saveData"
        />
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :disabled="isEdit"
        :model="conditions"
        :rules="rules"
        :show-message="false"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="billCode" label="月度计划编号">
              <el-input
                v-model="conditions.billCode"
                disabled
                placeholder="自动生成"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="billType" label="创建人">
              <el-input
                v-model="conditions.createdByName"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="createdDate" label="创建时间">
              <el-input v-model="conditions.createdDate" disabled placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="partnerName" label="客户名称">
              <wly-input
                v-model="conditions.partnerName"
                input-type="customer"
                @enter="handleEnter"
                @handleSuffixClick="openDialog($event, '客户选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.customerType"
                disabled
                placeholder=""
                type="select"
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="pyear" label="计划年度">
              <el-date-picker
                v-model="conditions.pyear"
                type="year"
                value-format="yyyy"
                format="yyyy"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="明细信息" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button name="add" tip="增加" @click="insertData" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-select
                v-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'brand'
                "
                v-model="row[item.field]"
                size="mini"
                filterable
                @change="changeBrand($event, row)"
              >
                <el-option value="" />
                <el-option
                  v-for="selectItem in selectDataOptions['A0019']"
                  :key="selectItem.value"
                  :value="selectItem.value"
                  :label="selectItem.name"
                />
              </el-select>
              <el-input
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                type="number"
                :disabled="isEdit"
                size="mini"
                onkeyup="value = value.replace(/[^\d]/g, '')"
                @input="updateTotal(row)"
              />
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'zqdlx'
                "
                v-model="row[item.field]"
                size="mini"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['goodsPlanType']"
                  :key="selectItem.value"
                  :value="selectItem.value"
                  :label="selectItem.name"
                />
              </el-select>
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'zyxdy'
                "
                v-model="row[item.field]"
                size="mini"
                @change="zyxdyChange($event, row)"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['orgList']"
                  :key="selectItem.zzfld00001h"
                  :label="selectItem.mc_short"
                  :value="selectItem.zzfld00001h"
                />
              </el-select>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
      <btky-footer :form-data="conditions" />
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
        <product-select
          v-if="dialogTitle === '产品选择'"
          ref="dialogSelect"
          :query-params="{ customerCode: conditions.partner }"
        />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiMonthplanFindById } from '@/api/applyForGoods/monthly'
import { handlerFlow } from '@/api/flowHander'
import { apiSapClientFindInfo } from '@/api/common'

import { mapGetters } from 'vuex'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')

const rules = {
  partnerName: [{ required: true, message: '请选择客户', trigger: 'change' }],
  pyear: [{ required: true, message: '请选择年度', trigger: 'blur' }]
  // yxdy: [{ required: true, message: '请选择营销单元', trigger: 'blur' }]
}

export default {
  components: { ClientSelect, ProductSelect },
  data() {
    return {
      rules,
      loading: false,
      processKey: 'ztcrmTgpplanM1',
      dialogTitle: '',
      showDialog: false,
      errorList: [],
      validRules: {
        brand: [{ required: true, message: '请选择存货分类' }],
        m12Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m1Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m2Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m3Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m4Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m5Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m6Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m7Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m8Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m9Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m10Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ],
        m11Plan: [
          { required: true, message: '请填写计划量' },
          { type: 'number', message: '请输入正确格式' }
        ]
      },
      conditions: {
        id: '',
        bizId: '',
        taskId: '',
        zyear: '',
        yxdy: '',
        yxdyName: '',
        p: '',
        businessType: 'write',
        partner: '',
        status: 0,
        billCode: '',
        partnerName: '',
        customerType: '',
        createdDate: '',
        createdByName: '',
        ztcrmTgpplanM1List: []
      },
      selectDataOptions: {},
      currentRow: null,
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 30 },
          { field: 'brand', title: '存货分类', width: 150, slots: { default: 'brand' }},
          // { field: 'amtAllInit', title: '全年初始计划量', width: 110, slots: { default: 'amtAllInit' }},
          // { field: 'amountAll', title: '全年计划量', width: 80, slots: { default: 'amountAll' }},
          { field: 'zqdlx', title: '渠道类型', width: 100, slots: { default: 'zqdlx' }},
          { field: 'qdjhl', title: '渠道计划量', width: 100, slots: { default: 'qdjhl' }},
          // { field: 'amtAllqdInit', title: '全年渠道初始计划量', width: 140, slots: { default: 'amtAllqdInit' }},
          { field: 'zyxdy', title: '营销单元', width: 150, slots: { default: 'zyxdy' }},
          { field: 'm12Plan', title: '12月计划量(件)', width: 110, slots: { default: 'm12Plan' }},
          { field: 'm1Plan', title: '1月计划量(件)', width: 100, slots: { default: 'm1Plan' }},
          { field: 'm2Plan', title: '2月计划量(件)', width: 100, slots: { default: 'm2Plan' }},
          { field: 'm3Plan', title: '3月计划量(件)', width: 100, slots: { default: 'm3Plan' }},
          { field: 'm4Plan', title: '4月计划量(件)', width: 100, slots: { default: 'm4Plan' }},
          { field: 'm5Plan', title: '5月计划量(件)', width: 100, slots: { default: 'm5Plan' }},
          { field: 'm6Plan', title: '6月计划量(件)', width: 100, slots: { default: 'm6Plan' }},
          { field: 'm7Plan', title: '7月计划量(件)', width: 100, slots: { default: 'm7Plan' }},
          { field: 'm8Plan', title: '8月计划量(件)', width: 100, slots: { default: 'm8Plan' }},
          { field: 'm9Plan', title: '9月计划量(件)', width: 100, slots: { default: 'm9Plan' }},
          { field: 'm10Plan', title: '10月计划量(件)', width: 110, slots: { default: 'm10Plan' }},
          { field: 'm11Plan', title: '11月计划量(件)', width: 110, slots: { default: 'm11Plan' }},
          { field: 'initPlanNum', title: '待分解量(件)', width: 100, slots: { default: 'initPlanNum' }}
        ],
        data: [],
        columnsFieldTypes: {
          brand: 'select',
          zqdlx: 'select',
          zyxdy: 'select',
          // amtAllqdInit: 'input',
          // amtAllInit: 'input',
          // qdjhl: 'input',
          m1Plan: 'input',
          m2Plan: 'input',
          m3Plan: 'input',
          m4Plan: 'input',
          m5Plan: 'input',
          m6Plan: 'input',
          m7Plan: 'input',
          m8Plan: 'input',
          m9Plan: 'input',
          m10Plan: 'input',
          m11Plan: 'input',
          m12Plan: 'input',
          initPlanNum: 'input'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isEdit() {
      return false
    }
  },
  watch: {
    'gridOptions.data': {
      handler(newVal) {
        this.conditions.ztcrmTgpplanM1List = newVal
      },
      deep: true
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0054')
    this.getSelectDictDataOrigin('goodsPlanType')
    this.getSelectDictDataOrigin('A0019')
    const { id, taskId } = this.$route.query
    if (id) {
      this.conditions.id = id
      this.conditions.bizId = id
      taskId && (this.conditions.taskId = taskId)
      this.initDetail()
    } else {
      this.conditions.createdByName = this.userInfo.name
      this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
      this.insertData()
    }
  },
  methods: {
    changeBrand(e, row) {
      if (!e) return
      this.currentRow = row

      // 获取存货分类名称
      const name = this.selectDataOptions['A0019'].find(v => v.value === e).name
      if (this.gridOptions.data.length > 1 && this.gridOptions.data.filter(v => v.brand === e).length > 1) {
        this.errorList = [`已存在存货分类：${name}！`]
        this.currentRow.brand = ''
        this.currentRow.brandName = ''
      } else {
        this.currentRow.brandName = name
      }
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      this.conditions.partner = data.customerCode
      this.conditions.partnerName = data.customerName
      this.conditions.customerType = data.customerType
      this.$set(this.selectDataOptions, 'orgList', data.orgList)
    },
    initDetail() {
      apiMonthplanFindById(this.conditions).then(res => {
        res.data.pyear += ''
        this.conditions = { ...this.conditions, ...res.data }
        this.gridOptions.data = res.data.ztcrmTgpplanM1List || []
        this.initCustome()
      })
    },
    // 查询客户信息
    async initCustome() {
      const params = { rt_partner: [{
        SIGN: 'I',
        OPTION: 'EQ',
        LOW: this.conditions.partner,
        HIGH: ''
      }], page: 1, pagesize: 50 }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0]?.yxdy || [])
    },
    zyxdyChange(e, row) {
      try {
        row.zyxdyName = this.selectDataOptions['orgList'].find(v => v.zzfld00001h === e).mc_short
      } catch (e) {
        row.zyxdyName = ''
      }
    },
    saveData() {
      this.errorList = []
      const params = JSON.parse(JSON.stringify(this.conditions))
      const _this = this
      _this.$refs['form'].validate((valid, err) => {
        if (valid) {
          _this.$refs.xTable.validate(_this.gridOptions.data, function(data) {
            if (!data) {
              _this.loading = true
              handlerFlow(params, _this.processKey)
                .then(response => {
                  _this.loading = false
                  if (!_this.conditions.id) {
                    _this.conditions.id = response.data.bizId
                    Object.assign(_this.conditions, response.data.bizData)
                    _this.conditions.bizId = response.data.bizId
                    _this.conditions.taskId = response.data.taskId
                    _this.conditions.billCode = response.data.bizData.billCode
                  }
                  response.data.bizData.ztcrmTgpplanM1List.map(item => {
                    item.zyxdyOptions = _this.selectDataOptions['orgList']
                  })
                  _this.gridOptions.data = response.data.bizData.ztcrmTgpplanM1List
                  _this.$message.success('保存成功')
                })
                .catch(() => {
                  _this.loading = false
                })
            }
          })
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return
      if (this.dialogTitle === '客户选择') {
        this.conditions.partner = data.customerCode
        this.conditions.partnerName = data.customerName
        this.conditions.customerType = data.customerType

        this.$set(this.selectDataOptions, 'orgList', data.orgList)
      } else {
        let productNum = 0
        this.gridOptions.data.map(item => {
          if (item.brand === data.brand) {
            productNum++
          }
        })
        if (productNum > 2) {
          this.$message.info('同一个存货分类，同一渠道类型不能超过两条')
          return
        }
        this.currentRow.brand = data.brand
        this.currentRow.brandName = data.brandName
        console.log(data)
      }
      this.showDialog = false
    },
    validate(cb) {
      this.errorList = []
      this.$refs['form'].validate((valid, err) => {
        if (valid) {
          cb()
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    insertData() {
      const columns = this.gridOptions.columns.filter(v => !v.type).map(v => v.field)
      const data = {}
      columns.forEach(key => {
        data[key] = ''
      })
      data.zqdlx = '0'
      if (this.selectDataOptions['orgList']?.length) {
        data.zyxdy = this.selectDataOptions['orgList'][0].zzfld00001h
        data.zyxdyName = this.selectDataOptions['orgList'][0].mc_short
      }
      this.gridOptions.data.push(data)
    },
    updateTotal(item) {
      item.qdjhl =
        Number(item.m1Plan) +
        Number(item.m2Plan) +
        Number(item.m3Plan) +
        Number(item.m4Plan) +
        Number(item.m5Plan) +
        Number(item.m6Plan) +
        Number(item.m7Plan) +
        Number(item.m8Plan) +
        Number(item.m9Plan) +
        Number(item.m10Plan) +
        Number(item.m11Plan) +
        Number(item.m12Plan)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 10px;
  text-align: left;
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliveryPlan.vue